<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Meus dados</span>
      <span class="titulo-contexto">
        O que o sistema guarda da sua conta. Para corrigir algo, fale com a coordenação.
      </span>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="carregando-lista" *ngIf="carregando && !usuario">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Carregando seus dados…</span>
    </div>

    <p class="vazio erro" *ngIf="erro">{{ erro }}</p>

    <dl class="meus-dados-lista" *ngIf="usuario">
      <div class="dado">
        <dt>Nome</dt>
        <dd>{{ ou(usuario.nome) }}</dd>
      </div>
      <div class="dado">
        <dt>Login</dt>
        <dd>{{ ou(usuario.login) }}</dd>
      </div>
      <div class="dado">
        <dt>CPF</dt>
        <dd>{{ cpfFormatado }}</dd>
      </div>
      <div class="dado">
        <dt>Telefone</dt>
        <dd>{{ ou(usuario.telefone) }}</dd>
      </div>
      <div class="dado">
        <dt>E-mail</dt>
        <dd>{{ ou(usuario.email) }}</dd>
      </div>
      <div class="dado">
        <dt>Acesso</dt>
        <dd>
          <span class="tag-perfil" *ngFor="let p of perfis">{{ p }}</span>
          <span *ngIf="!perfis.length">—</span>
        </dd>
      </div>
    </dl>
  </nb-card-body>
</nb-card>
